import { ScrollTrigger } from '../global/gsap';

const initPinned = (elements) => {
    ScrollTrigger.batch(elements, {
        start: 'bottom bottom',
        pin: true,
        pinSpacing: false,
        invalidateOnRefresh: true
    });
};

export { initPinned as default };
